<template>
  <div class="scroll">
  <div class="all-media">
    <div class="top-nav">
      <back-button cssClass="reverse"></back-button>
      <help-button cssClass="reverse"></help-button>
    </div>

    <header>
        <div class="fimg">
          <img class="flower-pic grid-item" :src="exhibitdata.image">
        </div>
        <div class="header-copy grid-item">
            <h1>{{ exhibit.name }}</h1>
            <h2>Media Library</h2>
        </div>
    </header>
    <section class="g-about">
      <h3 class="grid-item">ABOUT</h3>
      <div class="textbox" v-if="exhibitdata" v-html="exhibitdata.description"></div>
    </section>

    <section v-if="exhibitdata.letters" class="g-letters">
        <div class="grid">
          <h3 class="grid-item">Georgia's letters</h3>
          <div v-for="(letter,index) in exhibitdata.letters" :key="index" class="grid-item"><button @click="$router.push('letters/' + index)">Letter {{ index + 1 }}</button></div>
        </div>
    </section>

    <section v-if="exhibitdata.videos" class="videos" v-bind:data-v="this.$route.params.exhibitslug">
      <div class="grid video_wrapper">
        <h3 class="grid-item">Video</h3>
        <router-link v-for="(video,index) in exhibitdata.videos" :to="'videos/' + index" :key="index"><img :src="video.cover.url"></router-link>
      </div>
    </section>

    <div id="allGalleries" v-if="exhibitdata.galleries" v-bind:data-p="this.$route.params.exhibitslug">
      <section class="photos" v-for="(gallery,gidx) in exhibitdata.galleries" :key="gidx" >
        <div class="grid">
          <h3 class="grid-item" v-if="gallery.season == 1">Spring</h3>
          <h3 class="grid-item" v-if="gallery.season == 2">Summer</h3>
          <h3 class="grid-item" v-if="gallery.season == 3">Fall</h3>
          <h3 class="grid-item" v-if="gallery.season == 4">Winter</h3>
          <div class="photo grid-item" v-for="(photo,pidx) in gallery.gallery" :key="pidx">
            <router-link :to="'photos/' + gidx +'/' + pidx"><img :src="photo.url"></router-link>
          </div>
        </div>
      </section>
    </div>

    <section v-if="exhibitdata.audio_files" class="audios" v-bind:data-a="this.$route.params.exhibitslug">
      <div class="grid">
        <h3 class="grid-item">Audio</h3>
        <div v-for="(audiofile,index) in exhibitdata.audio_files" class="audio grid-item" :key="index">
          <p>{{ audiofile.title }}</p>
          <p>
            <plyr ref="plyrinstance" :options="{fullscreen: { enabled: true }, controls: ['play', 'progress', 'current-time']}">
              <!-- <audio :poster="audiofile.cover.url"> -->
              <audio>
                <source :src="audiofile.file" type="audio/mp4">
              </audio>
            </plyr>
          </p>
          <p><router-link class="button" :to="'audio/' + index">View transcript</router-link></p>
        </div>
      </div>
    </section>

  </div>
</div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

export default {
  name: 'allmedia',
  components: {},
  props: {
    exhibitslug: String
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    }
  },
  methods: {
    distance (id) {
      return Math.round(this.$store.state.distances[id] * 3.2808)
    },
    link (id) {
      return { name: 'exhibit', params: { exhibitid: id } }
    }
  }
}
</script>
<style type="text/css">
  .plyr--audio .plyr__controls {
    background: #000;
    padding: 0px 10px;
  }
</style>
<style lang="scss" scoped>
section {
    padding: 30px;
}

.grid {
    padding: 30px;
    grid-gap: 15px;
}

.scroll {
  height: 100%;
  overflow:auto;
}
.all-media {
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left:auto;
  margin-right:auto;
}

.all-media .top-nav {
    display: flex;
    justify-content: space-between;
    background-color: #000000;
    padding: 10px;
}


/*** HEADER ***/
header {
    background-color: black;
    color: white;
    padding: 30px;
    // display: grid;
    // grid-gap: 15px;
    // grid-template-columns: 1fr 3fr;
    // grid-template-rows: 1fr;
    display: flex;
}
header .fimg {
    // grid-column-start: 1;
    // grid-column-end: 2;
    // grid-row-start: 1;
    // grid-row-end: 2;
    // width: 220px;
    // height:100%;
    width: 25%;
}
header h1 {
    font-family: "akzidenz-grotesk", Helvetica, Arial, sans-serif;
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: capitalize;
    margin: 0;
    text-align: left;
}
header h2 {
    text-transform: uppercase;
    margin: 0;
    font-size: 0.7em;
    font-weight: normal;
    text-align: left;
}
header .header-copy {
    // align-self: center;
    letter-spacing: 2px;
    flex: 1;
    align-self: center;
    padding-left: 15px;
}

section.g-about h3 {
    text-transform: uppercase;
    font-weight: normal;
    text-align: center;
}


/*** LETTERS SECTION ***/
section.g-letters {
    background: url(../assets/letters/letters-media-bg.jpg) no-repeat center center #b0a47a;
    background-size: 160%;
}
section.g-letters .grid {
    background-color: white;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
section.g-letters .grid-item {
    justify-self: center;
}
.g-letters h3 {
    grid-column: 1 / -1;
}
.g-letters button {
    background-color: #aaa;
    color: white;
    border-radius: 20px;
    font-size: 1.1em;
    padding: 1em;
    text-transform: uppercase;
}


/*** VIDEOS SECTION ***/
section.videos {
    background: url(../assets/backgrounds/all-media-bg.jpg) no-repeat center center #b0a47a;
    background-size: 300%;
}
section.videos .grid {
    background-color: white;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
section.videos .grid-item {
    justify-self: center;
}
.videos h3 {
    grid-column: 1 / -1;
}

.video_wrapper a{
    margin-left: 50%;
    width: 100%;
}


/*** PHOTOS SECTION ***/
div#allGalleries {
    background: url(../assets/backgrounds/landscape.jpg) no-repeat center center #b0a47a;
    background-size: cover;
}
section.photos .grid {
    background-color: white;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}
section.photos .grid-item {
    justify-self: center;
}

.photos h3 {
    grid-column: 1 / -1;

}


/*** AUDIOS SECTION ***/
section.audios {
    background-color: white;
}
section.audios .grid {
    background-color: white;
    display: grid;
    grid-template-columns: 1fr;
}
section.audios .grid-item {
    justify-self: center;
}

section.audios h3 {
    grid-column: 1 / -1;
}
section.audios button {
    padding: 1rem 4rem;
    border-radius: 20px;
    font-size: 1.1rem;
}

/*** FOOTER ***/
footer {
    background-color: black;
    color: white;
    text-transform: uppercase;
}
footer button {
    background-color: white;
    color: black;
    padding: 1em;
    border-radius: 15px;
    text-transform: uppercase;
}

// [data-p='bog-room'] .photos{
//     background: url(../assets/backgrounds/all-media-bg.jpg) no-repeat center center #b0a47a;
// }

section.videos{
    background: #000000;
}
</style>
